import React from 'react'

function UserMenu() {

    const role_lead_auditor_auditor_manager = ["Manager"];
    const role_management_accounts_assi_auditor = ["Management","Accounts"];
    const role_client = ["Client"];
    const role_executive_support = ["Executive(Support)"];
    const role_auditors=["Lead Auditor","Auditor","Asst Auditor"]


    function auditors() {
        return (
            <div>
                <div id="layoutSidenav_nav">
                    <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div class="sb-sidenav-menu">
                            <div class="nav">
                                <div class="sb-sidenav-menu-heading">Core</div>
                                <a class="nav-link" href="index.html">
                                    <div class="sb-nav-link-icon"><i class="fas fa-tachometer-alt"></i></div>
                                    {localStorage.getItem("fullName")}
                                    <br/>
                                    {localStorage.getItem("userRole")}
                                </a>
                                <div class="sb-sidenav-menu-heading">Interface</div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 1
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>
                                <div class="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/auditlist">Client List</a>
                                        <a class="nav-link" href="/user/auditplan">Audit Plan</a>
                                        <a class="nav-link" href="/user/auditobservation">Audit Observation</a>
                                        <a class="nav-link" href="/user/stage1auditreport">Audit Report</a>
                                        <a class="nav-link" href="/user/reviewofauditprocesses">Review of Audit</a>
                                        <a class="nav-link" href="/user/auditeedetails">Auditee Details</a>
                                        <a class="nav-link" href="/user/attendancesheet">Audit Attendance Sheet</a>
                                        <a class="nav-link" href="/user/imsstage1auditreport">Ims Stage1 Audit Report</a>
                                        <a class="nav-link" href="/user/emsstage1auditreport">Ems Stage1 Audit Report</a>
                                        <a class="nav-link" href="/user/ohsmsstage1auditreport">Ohsms Stage1 Audit Report</a>
                                    </nav>
                                </div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage2" aria-expanded="false" aria-controls="collapseStage2">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 2
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>

                                <div class="collapse" id="collapseStage2" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/stage2auditlist">Client List</a>
                                        <a class="nav-link" href="/user/stage2auditplan">Audit Plan</a>
                                        <a class="nav-link" href="/user/auditreport">Audit Reports</a>
                                        <a class="nav-link" href="/user/stage2auditreportiso27001">Audit Reports(ISO 27001)</a> 
                                        <a class="nav-link" href="/user/imsstage2auditreport">Ims Stage 2 Audit Report</a>
                                        <a class="nav-link" href="/user/certificatedeccommittee">CDC deliberation & decision</a>
                                        <a class="nav-link" href="/user/approvalofteamleader"> Team Lead Approval</a>
                                        <a class="nav-link" href="/user/stage2reviewofaudit">Review of Audit</a>
                                        <a class="nav-link" href="/user/correctiveactionreport">Corrective Action Report</a>
                                        <a class="nav-link" href="/user/stage2auditobservationsheet">Audit Observation</a>
                                    </nav>
                                </div>
                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage5" aria-expanded="false" aria-controls="collapseStage2">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                           Surveillance 
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapseStage5" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                           <a class="nav-link" href="/user/surveillancelist">Client List</a>
                            <a class="nav-link" href="/user/surveillanceauditassign">Audit Assign</a> 
                            <a class="nav-link" href="/user/surveillanceobservation">Audit Observation</a>
                            <a class="nav-link" href="/user/auditplanmatrix">Audit Plan Matrix</a> 
                            <a class="nav-link" href="/user/bothsurveillancereports">Reports</a>


                           </nav>
                       </div> 
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }

    function assistant_auditor(){
        return (
            <div>
                <div id="layoutSidenav_nav">
                    <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div class="sb-sidenav-menu">
                            <div class="nav">
                                <div class="sb-sidenav-menu-heading">Core</div>
                                <a class="nav-link" href="index.html">
                                    <div class="sb-nav-link-icon"><i class="fas fa-tachometer-alt"></i></div>
                                    {localStorage.getItem("fullName")}
                                    <br/>
                                    {localStorage.getItem("userRole")}
                                </a>
                                <div class="sb-sidenav-menu-heading">Interface</div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 1
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>
                                <div class="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/auditlist">Client List</a>
                                        <a class="nav-link" href="/user/rfq">RFQ</a>
                                        <a class="nav-link" href="/user/auditplan">Audit Plan</a>
                                        <a class="nav-link" href="/user/auditobservation">Audit Observation</a>
                                        <a class="nav-link" href="/user/reviewofauditprocesses">Review of Audit</a>
                                        <a class="nav-link" href="/user/auditeedetails">Auditee Details</a>
                                        <a class="nav-link" href="/user/attendancesheet">Audit Attendance Sheet</a>
                                    </nav>
                                </div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage2" aria-expanded="false" aria-controls="collapseStage2">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 2
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>

                                <div class="collapse" id="collapseStage2" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/stage2auditlist">Client List</a>
                                        <a class="nav-link" href="/user/stage2auditplan">Audit Plan</a>
                                        <a class="nav-link" href="/user/auditreport">Audit Reports</a>
                                        <a class="nav-link" href="/user/certificatedeccommittee">CDC deliberation & decision</a>
                                        <a class="nav-link" href="/user/approvalofteamleader"> Team Lead Approval</a>
                                        <a class="nav-link" href="/user/stage2reviewofaudit">Review of Audit</a>
                                        <a class="nav-link" href="/user/correctiveactionreport">Corrective Action Report</a>
                                        <a class="nav-link" href="/user/stage2auditobservationsheet">Audit Observation</a>
                                    </nav>
                                </div>
                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage5" aria-expanded="false" aria-controls="collapseStage2">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                           Surveillance 
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapseStage5" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                           <a class="nav-link" href="/user/surveillancelist">Client List</a>
                            <a class="nav-link" href="/user/surveillanceauditassign">Audit Assign</a> 
                            <a class="nav-link" href="/user/surveillanceobservation">Audit Observation</a>
                            <a class="nav-link" href="/user/auditplanmatrix">Audit Plan Matrix</a> 
                           


                           </nav>
                       </div> 
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }
    function lead_auditor_auditor_manager() {
        return (
            <div>
                <div id="layoutSidenav_nav">
                    <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div class="sb-sidenav-menu">
                            <div class="nav">
                                <div class="sb-sidenav-menu-heading">Profile</div>
                                <a class="nav-link" href="index.html">
                                    <div class="sb-nav-link-icon"><i class="fas fa-tachometer-alt"></i></div>
                                    {localStorage.getItem("fullName")}
                                    <br/>
                                    {localStorage.getItem("userRole")}
                                </a>
                                <div class="sb-sidenav-menu-heading">Interface</div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 1
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>
                                <div class="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/auditlist">Client List</a>
                                        <a class="nav-link" href="/user/rfq">RFQ</a>
                                        <a class="nav-link" href="/user/contractreview">Contract Review</a>
                                        <a class="nav-link" href="/user/auditagreements">Audit Agreement</a>
                                        <a class="nav-link" href="/user/auditteamproposal">Audit Team Proposal</a>
                                        <a class="nav-link" href="/user/auditplan">Audit Plan</a>
                                        <a class="nav-link" href="/user/auditobservation">Audit Observation</a>
                                        <a class="nav-link" href="/user/reviewofauditprocesses">Review of Audit</a>
                                        <a class="nav-link" href="/user/auditeedetails">Auditee Details</a>
                                        <a class="nav-link" href="/user/attendancesheet">Audit Attendance Sheet</a>
                                    </nav>
                                </div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage2" aria-expanded="false" aria-controls="collapseStage2">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 2
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>

                                <div class="collapse" id="collapseStage2" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/stage2auditlist">Client List</a>
                                        <a class="nav-link" href="/user/stage2auditplan">Audit Plan</a>
                                        <a class="nav-link" href="/user/auditreport">Audit Reports</a>
                                        <a class="nav-link" href="/user/certificatedeccommittee">CDC deliberation & decision</a>
                                        <a class="nav-link" href="/user/approvalofteamleader"> Team Lead Approval</a>
                                        <a class="nav-link" href="/user/stage2reviewofaudit">Review of Audit</a>
                                        <a class="nav-link" href="/user/correctiveactionreport">Corrective Action Report</a>
                                        <a class="nav-link" href="/user/stage2auditobservationsheet">Audit Observation</a>
                                    </nav>
                                </div>
                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapsecertistatus" aria-expanded="false" aria-controls="collapseStage2">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Certification Status
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>

                                <div class="collapse" id="collapsecertistatus" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        {/* <a class="nav-link" href="/user/certificationstatus">Client List</a>
                                        <a class="nav-link" href="/user/stage2auditplan">Audit Plan</a>
                                        <a class="nav-link" href="/user/auditreport">Audit Reports</a> */}
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }

    function management_accounts_assi_auditor(){
        return(
            <div>
                <div id="layoutSidenav_nav">
                    <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div class="sb-sidenav-menu">
                            <div class="nav">
                                <div class="sb-sidenav-menu-heading">Profile</div>
                                <a class="nav-link" href="index.html">
                                    <div class="sb-nav-link-icon"><i class="fas fa-tachometer-alt"></i></div>
                                    {localStorage.getItem("fullName")}
                                    <br/>
                                    {localStorage.getItem("userRole")}
                                </a>
                                <div class="sb-sidenav-menu-heading">Interface</div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 1
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>
                                <div class="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/auditlist">Client List</a>
                                    </nav>
                                </div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage2" aria-expanded="false" aria-controls="collapseStage2">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 2
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>

                                <div class="collapse" id="collapseStage2" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/stage2auditlist">Client List</a>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }

    function client() {
        return (
            <div>
                <div id="layoutSidenav_nav">
                    <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div class="sb-sidenav-menu">
                            <div class="nav">
                                <div class="sb-sidenav-menu-heading">Profile</div>
                                <a class="nav-link" href="index.html">
                                    <div class="sb-nav-link-icon"><i class="fas fa-tachometer-alt"></i></div>
                                    {localStorage.getItem("fullName")}
                                    <br/>
                                    {localStorage.getItem("userRole")}
                                </a>
                                <div class="sb-sidenav-menu-heading">Interface</div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 1
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>
                                <div class="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/auditlist">Client List</a>
                                        <a class="nav-link" href="/user/rfq">RFQ</a>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }

    function executive_support() {
        return (
            <div>
                <div id="layoutSidenav_nav">
                    <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div class="sb-sidenav-menu">
                            <div class="nav">
                                <div class="sb-sidenav-menu-heading">Profile</div>
                                <a class="nav-link" href="">
                                    <div class="sb-nav-link-icon"><i class="fa fa-user"></i></div>
                                    
                                    {localStorage.getItem("fullName")} 
                                    <br/>
                                    {localStorage.getItem("userRole")} 
                                </a>
                                <div class="sb-sidenav-menu-heading">Menu</div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 1
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>
                                <div class="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                        <a class="nav-link" href="/user/auditlist">Client List</a>
                                        <a class="nav-link" href="/user/rfq">RFQ</a>
                                        <a class="nav-link" href="/user/contractreview">Contract Review</a>
                                        <a class="nav-link" href="/user/auditagreements">Audit Agreement</a>
                                        <a class="nav-link" href="/user/auditteamproposal">Audit Team Proposal</a>
                                    </nav>
                                </div>

                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage2" aria-expanded="false" aria-controls="collapseStage2">
                                    <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                                    Stage 2
                                    <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                                </a>

                                <div class="collapse" id="collapseStage2" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav class="sb-sidenav-menu-nested nav">
                                    <a class="nav-link" href="/user/stage2auditlist">Client List</a>
                                        <a class="nav-link" href="/user/stage2auditplan">Audit Plan</a>
                                        <a class="nav-link" href="/user/auditreport">Audit Reports</a>
                                        <a class="nav-link" href="/user/certificatedeccommittee">CDC deliberation & decision</a>
                                        <a class="nav-link" href="/user/approvalofteamleader"> Team Lead Approval</a>
                                        <a class="nav-link" href="/user/stage2reviewofaudit">Review of Audit</a>
                                        <a class="nav-link" href="/user/correctiveactionreport">Corrective Action Report</a>
                                        <a class="nav-link" href="/user/stage2auditobservationsheet">Audit Observation</a>
                                      
                                    </nav>
                                </div>
                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage5" aria-expanded="false" aria-controls="collapseStage2">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                           Surveillance 
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapseStage5" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                           <a class="nav-link" href="/user/surveillancelist">Client List</a>
                            <a class="nav-link" href="/user/surveillanceauditassign">Audit Assign</a> 
                            <a class="nav-link" href="/user/surveillanceobservation">Audit Observation</a>
                            <a class="nav-link" href="/user/auditplanmatrix">Audit Plan Matrix</a> 
                            <a class="nav-link" href="/user/bothsurveillancereports">Reports</a>



                           </nav>
                       </div> 
                                <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseStage4" aria-expanded="false" aria-controls="collapseStage2">
                           <div class="sb-nav-link-icon"><i class="fas fa-columns"></i></div>
                           User Management
                           <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
                       </a>
                       <div class="collapse" id="collapseStage4" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                           <nav class="sb-sidenav-menu-nested nav">
                           <a class="nav-link" href="/user/register">Register User</a> 
                               <a class="nav-link" href="/user/listuser">List Of User</a> 
                              
                              
                           </nav>
                       </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }

    function other_user(){
        return(
            <div>
                <h1>User Not Found</h1>
            </div>
        )
    }
    function callMenuRoleWise(){
       
        switch(localStorage.getItem("userRole")){
            case 'Lead Auditor':
            case 'Auditor':
            
                        return auditors();                        
                        break;
            case 'Asst Auditor':
                return assistant_auditor();
                       break;
                       
            case 'Manager':
                                return lead_auditor_auditor_manager();
                                break;
            case 'Management':
            case 'Accounts':
           
                                 return management_accounts_assi_auditor();
                                 break;
            case 'Client':      return client();
                                 break;
             case 'Executive(Support)':      return executive_support();
                                 break;
            default :  return other_user();
                            break;
        }
    }
    
    return(
        <div>
             {callMenuRoleWise()}
        </div>
          
        
    )
    
}

export default UserMenu
